import { ButtonProps } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

type LciReportDownloadButtonProps = {
  loading: boolean;
  userRole: string;
  onDownload: () => void;
  disabled?: boolean;
} & ButtonProps;

export const LciReportDownloadButton = ({
  loading,
  onDownload,
  disabled,
  ...buttonProps
}: LciReportDownloadButtonProps) => {
  return (
    <LoadingButton
      disabled={disabled}
      loadingPosition="start"
      loading={loading}
      onClick={onDownload}
      size="large"
      {...buttonProps}
    >
      LCI Report (.pptx)
    </LoadingButton>
  );
};
